module.exports = __webpack_public_path__ + "site/img/12.661433e4.jpg";